/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconDelta = createReactComponent("outline", "delta", "IconDelta", [["path", { "d": "M4 20h16l-8 -16z", "key": "svg-0" }]]);

export { IconDelta as default };
//# sourceMappingURL=IconDelta.mjs.map
